<template>
    <div>
        <div class="tile is-ancestor">
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <!-- 稿件审核概况 -->
                    <review-statistic :stat="stat" type="article"></review-statistic>
                    <div class="control">
                        <div class="filter-item">
                            <el-button type="primary" @click="entryAudit">白名单 </el-button>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <div class="tile is-ancestor">
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <h4 class="title is-4">列表</h4>
                    <div class="control">
                        <div class="filter-item">
                            审核队列:
                            <el-select v-model="filter.queue_level" filterable placeholder="选择来源" @change="search">
                                <el-option v-for="(item, key) in queueTypeList" :key="key" :label="item" :value="key">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="filter-item">
                            阅读人数排序:
                            <el-select v-model="filter.order" clearable @change="search" placeholder="请选择排序方式">
                                <el-option value="1" label="降序"></el-option>
                                <el-option value="2" label="升序"></el-option>
                            </el-select>
                        </div>
                        <div class="filter-item">
                            <el-date-picker
                                v-model="auditDateRange"
                                type="daterange"
                                @change="search"
                                placeholder="选择日期范围"
                            >
                            </el-date-picker>
                        </div>
                        <div class="filter-item">
                            <el-input placeholder="书籍ID" @keyup.enter.native="search" v-model.trim="filter.book_id">
                            </el-input>
                        </div>
                        <div class="filter-item">
                            <el-input
                                placeholder="书籍名称"
                                @keyup.enter.native="search"
                                v-model.trim="filter.book_name"
                            >
                            </el-input>
                        </div>
                        <div class="filter-item">
                            <el-input
                                placeholder="章节ID"
                                @keyup.enter.native="search"
                                v-model.trim="filter.content_id"
                            >
                            </el-input>
                        </div>
                        <div class="filter-item">
                            <el-button type="primary" @click="search">搜索</el-button>
                        </div>
                    </div>

                    <div class="control">
                        <el-table v-loading="loading" element-loading-text="拼命加载中" :data="list">
                            <el-table-column width="360" prop="book_id" label="书籍ID"> </el-table-column>
                            <el-table-column prop="book_name" label="书籍名称"> </el-table-column>
                            <el-table-column prop="content_id" label="章节ID"> </el-table-column>
                            <el-table-column prop="content_title" label="章节名称"> </el-table-column>
                            <el-table-column prop="create_time" label="提交时间"> </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button
                                        @click.native.prevent="toReviewView(scope.row.content_id)"
                                        type="primary"
                                        size="small"
                                    >
                                        审核
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="control">
                        <el-pagination
                            @current-change="handleCurrentChange"
                            :current-page="filter.page"
                            :page-size="filter.page_size"
                            layout="total, prev, pager, next, jumper"
                            :total="totalPageSize"
                        >
                        </el-pagination>
                    </div>
                </article>
            </div>
        </div>
    </div>
</template>

<style scrop>
.filter-item {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 10px;
}

.number {
    border-radius: 0;
}

.view-rest {
    margin-bottom: 10px;
}
</style>

<script>
import dateFormat from '@/common/js/DateFormat';
import auditListMixin from '@/common/mixin/auditListMixin';
import reviewStatistic from '@/common/widget/ReviewStatistic';
import QuRequest from '@/core/QuRequest';
const quRequest = new QuRequest();
// let {list, statistics} = quRequest.Apis.audit.contentReview
export default {
    mixins: [auditListMixin],
    components: {
        reviewStatistic
    },
    data () {
        return {
            list: [],
            groupList: [],
            sourceList: [],
            categoryList: [],
            filter: {
                page: 1,
                page_size: 30,
                product_key: 'midu',
                app_key: 'story',
                book_id: '',
                book_name: '',
                content_id: '',
                order: '',
                queue_level: '1',
                create_time_start: dateFormat(-7),
                create_time_end: dateFormat()
            },
            statistic: {},

            memberType: '',
            group: '',
            category: '',
            mergeCategory: [],
            filterMergeCategory: [],

            detailPathName: 'UserArticleReviewDetail',
            total_page: 1,
            disabled: true,
            loading: false,
            audit_start_date: '',
            audit_end_date: '',
            queueType: '1', // 审核队列
            queueTypeList: {
                1: '高热召回队列',
                // 2: '评论召回队列',
                // 3: '标题夸张队列',
                2: '用户投诉队列',
                // 5: '谣言召回队列',
                3: '截屏召回队列',
                4: 'TOP30召回队列'
            } // 审核队列列表
        };
    },
    methods: {
        entryAudit () {
            this.$router.push({
                name: 'WhiteList'
            });
        }
    }
};
</script>
